import Swiper from 'swiper';

class PageHomeSwiper {
  private swiper: Swiper | null = null;
  private voyageurBtn: HTMLElement | null;
  private profBtn: HTMLElement | null;

  constructor() {
    this.voyageurBtn = document.querySelector('.page-home__swiper-button-next');
    this.profBtn = document.querySelector('.page-home__swiper-button-prev');
    this._init();
    this._bindEvents();
  }

  private _init() {
    const swiperElement = document.querySelector('.page-home__swiper');
    if (swiperElement) {
      this.swiper = new Swiper(swiperElement as HTMLElement, {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
      });
    }
  }

  private _bindEvents() {
    if (this.voyageurBtn && this.profBtn) {
      this.voyageurBtn.addEventListener('click', () => {
        this._switchToVoyageur();
      });

      this.profBtn.addEventListener('click', () => {
        this._switchToProfessionnel();
      });
    }
  }

  private _switchToVoyageur() {
    if (this.swiper) {
      this.swiper.slideTo(0);
      this.voyageurBtn?.classList.add('active');
      this.profBtn?.classList.remove('active');
    }
  }

  private _switchToProfessionnel() {
    if (this.swiper) {
      this.swiper.slideTo(1);
      this.profBtn?.classList.add('active');
      this.voyageurBtn?.classList.remove('active');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PageHomeSwiper();
});
